// eslint-disable-next-line no-restricted-imports
import { Button as ArcButton, InputProps } from 'arc';
import { forwardRef, ForwardedRef, ReactElement, ComponentProps } from 'react';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const Button = forwardRef(function Button(
    props: ComponentProps<typeof ArcButton>,
    ref: ForwardedRef<HTMLButtonElement>
): ReactElement {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize as InputProps['size'], { frSizeOverride: 'lg' });
    return <ArcButton ref={ref} size={size} {...otherProps} />;
});
